<div class="about-nav" (click)="isVisible = true">
  <dpqa-icon iconName="info" [iconSize]="2" />
  <p>{{"COMMON.ABOUT" | translate}}</p>
</div>

<nz-modal [nzVisible]="isVisible" [nzTitle]="title" [nzWidth]="800" [nzFooter]="null" (nzOnCancel)="isVisible = false"
  [nzContent]="content" [nzWrapClassName]="'about-modal-container'">
</nz-modal>

<ng-template #title>
  <div class="about-title">
    <p class="about-title__name">
      Slide<span class="about-title__name--red">RightQA</span>
    </p>
    <nz-divider></nz-divider>
  </div>
</ng-template>

<ng-template #content>
  <div class="about-content">
    <p class="title">{{"COMMON.ABOUT" | translate}}</p>

    <div class="versions">
      @for(version of versions(); track version.name) {
      <div class="version">
        <p class="version__name">{{ version.name | translate }}:</p>
        <a href="#" class="version__value" (click)="$event.preventDefault(); copy(version.name)">{{ version.value }}</a>
      </div>
      }
    </div>

    <div class="external-links">
      @for(externalLink of externalLinks(); track externalLink.name) {
      <a class="external-link" (click)="clickExternalLink(externalLink.name)">
        <dpqa-icon [iconName]="externalLink.icon" iconSize="2"></dpqa-icon>
        <p class="external-link__name">{{ externalLink.name | translate }} >></p>
        @if(loadingExternalName() === externalLink.name) {
        <nz-spin nzSimple [nzIndicator]="indicatorTemplate" />
        }
      </a>
      }
    </div>

    <div class="manufacturer-information">
      <p class="manufacturer-information__title">{{"ABOUT.MANUFACTURER_INFORMATION" |translate}}</p>
      <p class="manufacturer-information__address" [innerHTML]="'ABOUT.BARCO_ADDRESS' | translate"></p>
    </div>
    <nz-divider></nz-divider>
    <div class="copyright">
      <p class="copyright__text">{{"ABOUT.COPYRIGHT" | translate}}</p>
      <img class="copyright__barco-logo" src="assets/images/barco.svg" />
    </div>
  </div>
</ng-template>

<ng-template #indicatorTemplate>
  <dpqa-loading-spinner />
</ng-template>
